import {connect} from "react-redux";
import PropTypes from "prop-types";
import React from 'react';


const trolleySpaceOccupationRate = ({spaceOccupationRate, freeCount, totalCount}) => {
  // X = nb d'emplacements libres et actifs ; Y = nb total d'emplacements actifs
  // (ceux qui forment le dénominateur du pourcentage). Affiché à côté du %
  // pour donner l'absolu, pas juste le ratio.
  const hasCounts = totalCount > 0;
  return (
    <div>
      <h4 style={{ display: 'flex', justifyContent: 'space-between', paddingRight: '2rem' }}>
        <span>
          Occupation des emplacements chariots:&nbsp;
          <span>{(spaceOccupationRate * 100).toFixed(1)} %</span>
          {hasCounts && <span>&nbsp;({freeCount}/{totalCount})</span>}
        </span>
      </h4>
    </div>
  );
};

trolleySpaceOccupationRate.propTypes = {
  spaceOccupationRate: PropTypes.number,
  freeCount: PropTypes.number,
  totalCount: PropTypes.number,
};


const mapStateToProps = state => {
  return {
    spaceOccupationRate: state.m.metas.trolleys_space_occupation_rate || 0,
    freeCount: state.m.metas.trolleys_space_free_count || 0,
    totalCount: state.m.metas.trolleys_space_total_count || 0,
  };
};


let TrolleySpaceOccupationRateConnected = connect(
  mapStateToProps
)(trolleySpaceOccupationRate);

export default TrolleySpaceOccupationRateConnected;
